/**
 * not implemented yet. Ideally this stores notifications and interactions
 * with the API.
 */
const state = {
  api: {
    message: '',
    code: null
  }
}
const mutations = {
  setApiNotification (state, {message, code}) {
    state.api.message = message
    state.api.code = code
  }
}
const getters = {
  largeMessage (state) {
    return state.api.message.length > 200
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations
}
